import React from "react";
import "./contact.scss";

// components
import Wrapper from "../../layouts/wrapper/Wrapper";
import CommonHeader from "../../common/commonHeader/CommonHeader";
import ContactCard from "../../cards/contactCard/ContactCard";

// data
import contactData from "../../../assets/data/contactData";
import ContactForm from "../../forms/contactForm/ContactForm";
import LayoutAnimations from "../../animations/LayoutAnimations";

const Contact = () => {
  return (
    <section id="contact">
      <Wrapper>
        <div className="contact">
          <CommonHeader
            title="Contact"
            subtitle="get in touch"
            bgText="contact"
            center={true}
          />

          <div className="contact__container">
            <LayoutAnimations propVarient={"leftToRight"}>
              <div className="contact__info">
                <span className="contact__infoTitle">Talk To Me</span>

                {contactData.map((contact) => (
                  <ContactCard key={contact.id} data={contact} />
                ))}
              </div>
            </LayoutAnimations>

            <LayoutAnimations propVarient={"rightToLeft"}>
              <div className="contact__formContainer">
                <span className="contact__infoTitle">Contact</span>

                <ContactForm />
              </div>
            </LayoutAnimations>
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default Contact;
